module.exports = __webpack_public_path__ + "img/clock-1.2c099539.svg";